import { QueryClient } from "@tanstack/vue-query";
import { useStorageStore } from "../store";
import { storeToRefs } from "pinia";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
    },
    mutations: {
      onError: (err) => {
        if (err.status === 401) {
          handlerToken()
        }
      },
    },
  },
});

queryClient.getQueryCache().config.onError = (err, query) => {
  if (query.state.fetchFailureCount === 3 && err.response.status === 401) {
    handlerToken()
  }
};

const handlerToken = () => {
  const storageStore = useStorageStore();
  const { token } = storeToRefs(storageStore);
  token.value = null;
};
